import { useEffect, useState } from 'react';
import BrandMark from '../components/BrandMark';
import { readSession, restoreSessionFromCookie } from './session';

export default function AuthGate({ children }) {
  const existing = readSession();
  const [ready, setReady] = useState(!!(existing?.token && existing.source !== 'cookie'));

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const session = readSession();
      if (session?.token && session.source !== 'cookie') {
        if (!cancelled) setReady(true);
        return;
      }
      await restoreSessionFromCookie();
      if (!cancelled) setReady(true);
    })();
    return () => { cancelled = true; };
  }, []);

  if (!ready) {
    return (
      <div className="shell sso-splash">
        <BrandMark />
        <p className="muted">Opening payroll…</p>
      </div>
    );
  }

  return children;
}
